import { useAuth, useDialog } from '@wui/common-library'
import { useIM } from '@wui/im'


import { useLiveCallSessions, useCallsStore } from '@/entities/calls'
import { useStoreContacts } from '@/entities/contact'
import { useChatMessageStore } from '@/entities/messages'
import { useStoreRooms } from '@/entities/room'
import { STATUS_CODES, useWebRTC } from '@/entities/webrtc'

import { useKerberosAutoLoginGuard } from '@/shared/composables/auth'
import { useAppBadge } from '@/shared/composables/browser-api'
import { useCallsNotifications } from '@/shared/composables/calls-notifications'
import { useStatusSubscribe } from '@/shared/composables/im'
import { useUserData } from '@/shared/composables/local-storage'
import { getAppURL } from '@/shared/utils/electron'
import { useFetchApi } from '@/shared/utils/fetch'

export const useLogoutHook = () => {
  const { logout: processLogout } = useAuth()
  const { closeAll } = useDialog()
  const { markSkipNextKerberosAutoLogin } = useKerberosAutoLoginGuard()

  const onBeforeLogout = () => {
    // Prevent immediate auto-login after explicit logout on login page.
    markSkipNextKerberosAutoLogin()
    useUserData().clear()
    const { liveCallSessions } = useLiveCallSessions()
    liveCallSessions.value.forEach(session => session.terminate({ status_code: STATUS_CODES.BUSY_HERE }))
    closeAll()
  }

  const onAfterLogout = () => {
    useWebRTC().stop()
    useIM().close().catch(() => ({}))
    useChatMessageStore().$reset()
    useStoreContacts().$reset()
    useStoreRooms().$reset()
    useCallsStore().$reset()
    useCallsNotifications().clear()
    useAppBadge().clearAppBadge().catch(() => ({}))
  }

  const disablePushNotifications = () => {
    const fetchApi = useFetchApi()
    const url = getAppURL({ pathName: '/api/user-device-token' })

    void fetchApi.post(url, {
      enabled: false,
      additionalData: 'web-client',
    }).catch(() => ({}))
  }

  const logout = () => {
    onBeforeLogout()
    disablePushNotifications()
    processLogout()
    onAfterLogout()
    useStatusSubscribe().reset()
  }

  return {
    logout,
  }
}
